<template>
  <div class="app_container">
    <div class="err-container">
      <img src="../../assets/image/welcome.png" alt="" />
    </div>
  </div>
</template>

<script>
// import NoBackgroundColor from "@/mixins/unset-bg";
import { getItem, setItem } from "@/utils/storage";
export default {
  // mixins: [NoBackgroundColor]
  created() {
    this.$store.commit("set_breadcrumd", []);
    if (getItem("refreshHome")) {
      setItem("refreshHome", false);
      location.reload();
    }
  },
};
</script>

<style lang="scss" scoped>
.err-container {
  width: 100%;
  height: 85vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
img {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}
.info-text {
  font-size: 16px;
  color: rgba(102, 102, 102, 1);
  line-height: 22px;
  text-align: center;
  margin-top: 24px;
}
</style>
